import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import MainApp from './MainApp';
import AdminPanel from './AdminPanel';
import PassoverGuard from './PassoverGuard';
import DriverManifestView from './DriverManifestView'; // Import the guard

function App() {
  const ADMIN_PATH = process.env.REACT_APP_ADMIN_PATH || "admin";

  return (
    <Routes>
      {/* 1. Public Customer Page - Now Protected by the Passover Guard */}
      <Route path="/" element={
        <PassoverGuard>
          <MainApp />
        </PassoverGuard>
      } />
      
      {/* 2. Secret Admin Page - Always accessible for management */}
      <Route path={`/${ADMIN_PATH}`} element={<AdminPanel />} />
     
<Route path="/manifest/:routeId" element={<DriverManifestView />} />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}

export default App;